var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpisodeManifestationBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom: series"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 38H36H12Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 38H36",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C2.89543 8 2 8.89543 2 10V33C2 34.1046 2.89543 35 4 35H44C45.1046 35 46 34.1046 46 33V10C46 8.89543 45.1046 8 44 8H4ZM17.9375 16.618C17.9375 15.8747 18.7198 15.3912 19.3847 15.7236L30.1486 21.1056C30.8857 21.4741 30.8857 22.5259 30.1486 22.8944L19.3847 28.2764C18.7198 28.6088 17.9375 28.1253 17.9375 27.382V16.618Z",
    fill: "black",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisodeManifestationBlack);
export default __webpack_public_path__ + "static/media/episode_manifestation_black.fd101a2f2729a0f4842951517fdb0573.svg";
export { ForwardRef as ReactComponent };